/** Admin yüklemesi veya kullanıcı düzenlemesi (Supabase Storage) */
export function isUserAutomobileImageUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== 'string') return false;
  const u = url.trim();
  if (!u) return false;
  return (
    u.includes('/storage/v1/object/public/automobile/') ||
    u.includes('/storage/v1/object/sign/automobile/') ||
    u.includes('supabase.co/storage/v1/object/public/automobile')
  );
}

/** Görsel URL'deki önbellek parametrelerini temizle */
export function stripImageCacheParams(url: string): string {
  return url
    .replace(/([?&])(v|t|cb)=[^&]*/gi, '')
    .replace(/\?&/, '?')
    .replace(/[?&]$/, '');
}

/** Kayıt / yükleme sonrası tarayıcı ve CDN önbelleğini kırmak için */
export function freshImageUrl(url: string | null | undefined): string | null {
  const base = stripImageCacheParams((url || '').trim());
  if (!base) return null;
  return `${base}?t=${Date.now()}`;
}

/** Canlı sitede Supabase updated_at ile önbellek kırma */
export function cacheBustAutomobileImageUrl(
  url: string | null | undefined,
  updatedAt?: string | null,
): string | null {
  const base = stripImageCacheParams((url || '').trim());
  if (!base) return null;
  if (updatedAt) {
    return `${base}?v=${encodeURIComponent(updatedAt)}`;
  }
  return base;
}
